<template>
  <div class="stil-kartice" v-if="seznamUmtsSt.length > 0" v-loading="showLoader">
    <div class="odmik-v-kartici">
      <div class="stil-desnega-naslova">
        <a href="/Poraba/PorabaTelefonija" class="brez-stila">
          PREGLED PORABE
        </a>
        <span class="odmik-desne-zgoraj-ikone">
          <img src="/static/img/dashboard/Icon-material-unfold-more-grey.png">
        </span>
      </div>
      <div style="float: left">
        <div class=" icon-left">
          <p class="open-sans-20pt">
            Poraba mobilne telefonije
          </p>
        </div>
      </div>
      <div style="clear: both"/>
      <div style="padding-top: 10px">
        <el-select class="velikost-izbirnika-telefonija"
                   v-model="izbranaUmtsTelStevilka" loading-text="Pregled Porabe"
                   placeholder="Izberite tel. številko">
          <el-option v-for="(data, key) in seznamUmtsSt" :value="data.telefonska_stevilka"
                     :label="VrniFormatiranoTelefonsko(data.telefonska_stevilka, data.tip_stevilke)"
                     :key="key">
          </el-option>
        </el-select>
      </div>
      <div style="padding-top: 30px;" v-if="porabaData !== null">
        <div class="row-poraba-telefonija">
          <div class="column-poraba-telefonija">
            <p class="open-sans-20pt mobilna-telefonija-postavitev-podatkov">
              {{ porabaData.skupnoSteviloKlicev }}
              <span class="navadno-besedilo" v-if="porabaData.maxStKlicev !== null && !this.infinitySymbol">
                / {{ porabaData.maxStKlicev }}
              </span>
              <span class="navadno-besedilo" v-if="porabaData.kliciUnit !== null && !this.infinitySymbol">
                {{ porabaData.kliciUnit }}
              </span>
              <span class="navadno-besedilo" v-if="this.infinitySymbol">
                / ∞
              </span>
            </p>
            <p class="navadno-besedilo postavitev-podatkov-poraba" v-if="!isMobilniTopPaket">
              Število Klicev
            </p>
            <p v-else class="navadno-besedilo postavitev-podatkov-poraba">Klici</p>
          </div>
          <div class="column-poraba-telefonija">
            <p class="open-sans-20pt mobilna-telefonija-postavitev-podatkov">
              {{ porabaData.message.steviloPoslanihSmsov }}
              <span class="navadno-besedilo" v-if="this.infinitySymbol">
                / ∞
              </span>
              <span class="navadno-besedilo" v-else>
                / {{ porabaData.message.maxPoslanihSmsov  }}
              </span>
              <span class="navadno-besedilo" v-if="porabaData.message.poslaniSmsUnit !== null">
                {{ porabaData.message.poslaniSmsUnit }}
              </span>
            </p>
            <p class="navadno-besedilo postavitev-podatkov-poraba">
              SMS/MMS
            </p>
          </div>
          <div class="column-poraba-telefonija">
            <p class="open-sans-20pt mobilna-telefonija-postavitev-podatkov">
              {{ porabaData.data.prenosPodatkovNational }}
              <span class="navadno-besedilo" v-if="porabaData.data.maxPrenosPodatkovNational !== null &&
               !porabaData.data.prenosPodatkovNationalNeomejeno">
                / {{ porabaData.data.maxPrenosPodatkovNational }}
              </span>
              <span v-if="porabaData.data.prenosPodatkovNationalNeomejeno" class="navadno-besedilo" style="color:black;">
                / ∞
              </span>
              <span class="navadno-besedilo" v-if="porabaData.data.maxPrenosPodatkovNational !== null &&
               !porabaData.data.prenosPodatkovNationalNeomejeno">
                {{ porabaData.data.prenosPodatkovNationalUnit }}
              </span>
            </p>
            <p class="navadno-besedilo postavitev-podatkov-poraba">
              Prenos podatkov v omrežju T-2
            </p>
          </div>
          <div class="column-poraba-telefonija">
            <p class="open-sans-20pt mobilna-telefonija-postavitev-podatkov">
              {{ porabaData.data.prenosPodatkovTS }}
              <span class="navadno-besedilo" v-if="porabaData.data.maxPrenosPodatkovTS !== null">
                / {{ porabaData.data.maxPrenosPodatkovTS }}
              </span>
              <span class="navadno-besedilo" v-if="porabaData.data.maxPrenosPodatkovTS !== null">
                {{ porabaData.data.maxPrenosPodatkovTSUnit }}
              </span>
            </p>
            <p class="navadno-besedilo postavitev-podatkov-poraba">
              Prenos podatkov v omrežju A1
            </p>
          </div>
        </div>
      </div>
      <div style="padding-top: 10px">
        <p>
          <span>
            <img src="/static/img/dashboard/Icon-awesome-info-circle.png" class="Icon-awesome-info-circle">
            <a class="info-box-poraba">
              Podatki za tekoče obračunsko obdobje.
            </a>
          </span>
        </p>
      </div>
    </div>
    <div style="clear: both"/>
  </div>
</template>

<script>
import {PorabaTelefonija} from '../../../../../assets/js/globalne_funkcije/PorabaTelefonija/PorabaTelefonija.js'
import {Select, Option} from 'element-ui'
import {FormatirajTelefonskoStevilko}
  from '../../../../../assets/js/globalne_funkcije/GlobalnoTelefonija/FormatTelefonskeStevilke.js'

export default {
  name: 'KarticaUmtsPoraba',
  components: {
    [Select.name]: Select,
    [Option.name]: Option
  },
  mixins: [PorabaTelefonija, FormatirajTelefonskoStevilko],
  data () {
    return {
      showLoader: false,
      izbranaUmtsTelStevilka: null,
      porabaData: null,
      isMobilniTopPaket: false,
      infinitySymbol: false
    }
  },
  props: {
    seznamUmtsSt: null,
    izbranSap: null,
    izbranaStevilka: null
  },
  methods: {
    PridobiPoraboStevilke (stevilka) {
      if (stevilka !== '') {
        let param = {}
        this.showLoader = true
        param.vmesnik = this
        this.PreveriTopPaket(stevilka)
        param.izbranaTelefonskaStevilka = stevilka
        param.callBackFunction = this.NastaviPoraba
        param.prenesenIzbranSap = this.izbranSap
        param.isMobilniTopPaket = this.isMobilniTopPaket
        this.porabaData = null
        this.GetPorabaInfo(param)
      }
    },
    NastaviPoraba (podatki) {
      this.porabaData = podatki
      this.showLoader = false
    },
    PreveriTopPaket (msisdn) {
      this.isMobilniTopPaket = false
      for (let i = 0; i < this.seznamUmtsSt.length; i++) {
        if (this.seznamUmtsSt[i].rezultat === msisdn && this.seznamUmtsSt[i].mobilni_top_paket === '1') {
          this.isMobilniTopPaket = true
          return true
        }
      }
    }
  },
  watch: {
    izbranaStevilka: function (stevilka) {
      if (typeof stevilka !== 'undefined' && stevilka !== null) {
        this.izbranaUmtsTelStevilka = stevilka
      }
    },
    izbranaUmtsTelStevilka (stevilka) {
      this.infinitySymbol = false
      for (let i = 0; i < this.seznamUmtsSt.length; i++) {
        if (this.seznamUmtsSt[i].telefonska_stevilka === stevilka) {
          if (this.seznamUmtsSt[i].trzni_paket === 'Oranžni Midi' ||
            this.seznamUmtsSt[i].trzni_paket === 'Oranžni Mini' ||
            this.seznamUmtsSt[i].trzni_paket === 'Oranžni Maxi') {
            this.infinitySymbol = true
          }
        }
      }
      this.PridobiPoraboStevilke(stevilka)
    }
  }
}
</script>

<style scoped src="../../../../../../static/css/Domov/naslovna-stran.css">
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Poraba/Komponente/KarticaUmtsPoraba.vue